import React, { useState, useEffect } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Input, Button, FormGroup, Label } from 'reactstrap';
import Select, { components } from 'react-select';
import { toast } from 'react-toastify';
import { cloneDeep } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import PriceUtils from '../../helpers/PriceUtils';
import { connect } from 'react-redux';
import { baseUrl } from '../../constants/environment';
import styled from 'styled-components';
import TextUtils from '../../helpers/TextUtils';
import NumberFormat from 'react-number-format';
import AsyncSelect from "react-select/async";
import { RenderActionModal, StatusList } from './StockimportList';
import { PaymentMethodList } from '../designation/DesignationAdd';
import BatchAdd from '../batch/BatchAdd';
import queryString from 'query-string';
import PaymentAdd from '../payment/PaymentAdd';
import SupplierList from '../supplier/SupplierList';
import ProductUtil from '../../helpers/ProductUtil';
import moment from 'moment';

export const DiscountType:any = [
    {
        value:'price',
        label: "Giá trị"
    },
    {
        value:'percent',
        label: "%"
    },
]
interface Props {
    history: any,
    location: any,
    match: any,
    user: any,
}

const Detail = (props: any) => {
    const {from,dataFromExam, setDataFromExam, closeModal, fetchCustomerExam} = props
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState(props?.match?.params?.id);
    const [onlyView, setOnlyView] = useState(false);
    const [data, setData] = useState<any>({
        branch_id: props?.user?.branch_id?.id,
        discount_type: 'price'
    });
    const [product, setProduct] = useState<any>([{
        product_id: "",
        quantity:"",
        unit_id:"",
    }])
    const [productTemplate, setProductTemplate] = useState<any>()
    const [stockRequestTemplate, setStockRequestTemplate] = useState<any>()
    const [modalIsOpen, setIsOpen] = useState(false);
    const [type, setType] = useState(props?.match?.params?.action);
    const [action, setAction] = useState<any>();
    const [branch, setBranch] = useState<any>([]);
    const [supplier, setSupplier] = useState<any>([]);
    const [supplierInfo, setSupplierInfo] = useState<any>();
    const [paymentMethod, setPaymentMethod] = useState([]);
    const [payment, setPayment] = useState<any>([{
        product_id: "",
        quantity:"",
    }])
    const searchPrams = queryString.parse(props.location.search)
    console.log("Detail", searchPrams)

    const [history, setHistory] = useState<any>();
    const router = useHistory()

    const loadHistory = async (id:number) => {
        const url = `${baseUrl}/stock/import/history/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response?.data;
            setHistory(resData)
        }
    }

    useEffect(() => {
        if (id && id !== 'add') {
            loadData(id)
            document.title = 'Chỉnh sửa phiếu nhập hàng'
            
        }else{
            document.title = 'Thêm mới phiếu nhập hàng'
        }
        if (type === 'view') {
            setOnlyView(true)
            loadHistory(id)
            document.title = 'Chi tiết phiếu nhập hàng'
        }
    }, [id]);

    useEffect(() => {
        if (searchPrams?.stockrequest_id) setData({
            ...data,
            stock_request_id: searchPrams?.stockrequest_id
        })
    }, [searchPrams?.stockrequest_id]);

    useEffect(() => {
        console.log("loadDataByStockRequest", id)
        if (data?.stock_request_id && (!id || (id && id === 'add'))) {
            loadDataByStockRequest(Number(data?.stock_request_id))
        }
    }, [data?.stock_request_id]);
    

    useEffect(() => {
        loadInit()
    }, []);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }
    
    const loadInit = async () => {
        const params = {
            status:1,
            page:1,
            limit: 200,
        }
        const [
            responseBranch,
            responseProductTemplate,
            responseSupplier,
            responseStockRequest,
            responsePaymentMethod
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/branch`, {
                ...params,
            }),
            APIClient.GET(`${baseUrl}/product`, {...params, limit: 10}),
            APIClient.GET(`${baseUrl}/supplier`, params),
            APIClient.GET(`${baseUrl}/stock/request`, {
                ...params,
                status: undefined
            }),
            APIClient.GET(`${baseUrl}/payment-method`, {
                ...params,
            }),
        ]);
        if (responsePaymentMethod.response?.data !== undefined) {
            let ListArr:any = [];
            responsePaymentMethod.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setPaymentMethod(ListArr)
        }
        if (responseBranch.response?.data !== undefined) {
            let ListArr:any = [];
            responseBranch.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setBranch(ListArr)
        }
        if (responseProductTemplate.response?.data !== undefined) {
            const ListArr = ProductUtil.parseProduct(responseProductTemplate.response?.data)
            setProductTemplate(ListArr)
        }
        if (responseSupplier.response?.data !== undefined) {
            let ListArr:any = [];
            responseSupplier.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setSupplier(ListArr)
        }
        if (responseStockRequest.response?.data !== undefined) {
            let ListArr:any = [];
            responseStockRequest.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.code
                })
            })
            setStockRequestTemplate(ListArr)
        }
    }

    const loadData = async (id:number) => {
        const url = `${baseUrl}/stock/import/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            const resDataProduct = response.response?.stock_import_products?.reduce((prev:any, item:any)=>{
                const product_units_lockup:any = {}
                product_units_lockup['root'] = {
                    name: item?.product_id?.minimum_unit,
                    quantity_conversion: 1,
                }
                item?.product_id?.product_units?.map((itemUnit:any)=>{
                    product_units_lockup[itemUnit?.quantity_conversion] = itemUnit
                })
                const product_variants = item?.product_id?.product_variants
                const product_variants_units:any = ProductUtil.parseProductUnit(item?.product_id, product_variants, product_units_lockup)
                let itemRoot = {
                    name: item?.product_id?.name,
                    sku: item?.product_id?.sku,
                    stock_max: item?.product_id?.stock_max,
                    stock_min: item?.product_id?.stock_min,
                    type: item?.product_id?.type,
                    status: item?.product_id?.status,
                    height: item?.product_id?.height,
                    weight: item?.product_id?.weight,
                    width: item?.product_id?.width,
                    longs: item?.product_id?.longs,
                    vat: item?.product_id?.vat,
                    price: item?.product_id?.price,
                    price_import: item?.product_id?.price_import,
                    price_wholesale: item?.product_id?.price_wholesale,
                    product_id: item?.product_id?.id,
                    variant_id: null,
                    value: `${item?.id}`,
                    label: item?.product_id?.name,
                    units: product_variants_units,
                    batchs: ProductUtil.parseProductBatch(item?.product_id?.product_batchs || [])
                }
                if(item?.variant_id){
                    const itemVariant = item?.variant_id
                    const product_variants_units:any = ProductUtil.parseProductUnit(itemVariant, product_variants, product_units_lockup)
                    itemRoot = {
                        ...itemRoot,
                        name: itemVariant?.name,
                        sku: itemVariant?.sku,
                        vat: itemVariant?.vat,
                        price: item?.price,
                        price_import: itemVariant?.price_import,
                        price_wholesale: itemVariant?.price_wholesale,
                        product_id: item?.id,
                        variant_id: itemVariant?.id,
                        value: `${item?.id}-${itemVariant?.id}`,
                        label: itemVariant?.name,
                        units: product_variants_units,
                        batchs: ProductUtil.parseProductBatch(itemVariant?.product_batchs || [])
                    }
                }
                prev = [...prev, {
                    id: item?.id,
                    product_id: item?.product_id?.id,
                    variant_id: item?.variant_id?.id,
                    product: itemRoot,
                    quantity: item?.quantity,
                    quantity_request: item?.quantity_request,
                    price: item?.price,
                    price_request: item?.price_request,
                    discount: item?.discount,
                    unit_id: item?.unit_id?.id || 0,
                    batch_id: item?.batch_id?.id || 0,
                }]
                return prev
            },[]);
            const dataTemp:any = {
                ...resData,
                branch_id: resData.branch_id?.id,
                supplier_id: resData.supplier_id?.id,
                stock_request_id: resData.stock_request_id?.id,
            }
            setData(dataTemp)
            setProduct(resDataProduct)
            setPayment(resData?.stock_import_payments?.reduce((prev:any, item:any)=>{
                prev = [...prev,{
                    ...item,
                    payment_method_id: item?.payment_method_id?.id
                }]
                return prev
            },[]))
            setSupplierInfo(resData.supplier_id)
        }
    }

    const loadDataByStockRequest = async (id:number) => {
        const url = `${baseUrl}/stock/request/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            const resDataProduct = response.response?.stock_request_products?.reduce((prev:any, item:any)=>{
                const product_units_lockup:any = {}
                product_units_lockup['root'] = {
                    name: item?.product_id?.minimum_unit,
                    quantity_conversion: 1,
                }
                item?.product_id?.product_units?.map((itemUnit:any)=>{
                    product_units_lockup[itemUnit?.quantity_conversion] = itemUnit
                })
                const product_variants = item?.product_id?.product_variants
                const product_variants_units:any = ProductUtil.parseProductUnit(item?.product_id, product_variants, product_units_lockup)
                let itemRoot = {
                    name: item?.product_id?.name,
                    sku: item?.product_id?.sku,
                    stock_max: item?.product_id?.stock_max,
                    stock_min: item?.product_id?.stock_min,
                    type: item?.product_id?.type,
                    status: item?.product_id?.status,
                    height: item?.product_id?.height,
                    weight: item?.product_id?.weight,
                    width: item?.product_id?.width,
                    longs: item?.product_id?.longs,
                    vat: item?.product_id?.vat,
                    price: item?.product_id?.price,
                    price_import: item?.product_id?.price_import,
                    price_wholesale: item?.product_id?.price_wholesale,
                    product_id: item?.product_id?.id,
                    variant_id: null,
                    value: `${item?.id}`,
                    label: item?.product_id?.name,
                    units: product_variants_units,
                    batchs: ProductUtil.parseProductBatch(item?.product_id?.product_batchs || [])
                }
                if(item?.variant_id){
                    const itemVariant = item?.variant_id
                    const product_variants_units:any = ProductUtil.parseProductUnit(itemVariant, product_variants, product_units_lockup)
                    itemRoot = {
                        ...itemRoot,
                        name: itemVariant?.name,
                        sku: itemVariant?.sku,
                        vat: itemVariant?.vat,
                        price: itemVariant?.price,
                        price_import: itemVariant?.price_import,
                        price_wholesale: itemVariant?.price_wholesale,
                        product_id: item?.id,
                        variant_id: itemVariant?.id,
                        value: `${item?.id}-${itemVariant?.id}`,
                        label: itemVariant?.name,
                        units: product_variants_units,
                        batchs: ProductUtil.parseProductBatch(itemVariant?.product_batchs || [])
                    }
                }
                prev = [...prev, {
                    product_id: item?.product_id?.id,
                    variant_id: item?.variant_id?.id,
                    product: itemRoot,
                    quantity: item?.quantity,
                    quantity_request: item?.quantity,
                    price: itemRoot?.price_import,
                    price_request: item?.price_request,
                    discount: item?.discount,
                    unit_id: item?.unit_id?.id || 0,
                    batch_id: item?.batch_id?.id || 0,
                }]
                return prev
            },[]);
            const dataTemp:any = {
                ...resData,
                status: null,
                code: null,
                branch_id: resData.branch_id?.id,
                stock_request_id: id,
            }
            console.log("resDataProduct", resDataProduct)
            setData(dataTemp)
            setProduct(resDataProduct)
        }
    }

    const handleUpdateBatch = (dataBatch:any, product_id:number, variant_id:number, indexProduct:number)=>{
        const products = product?.filter((item:any)=>{
            return item?.product_id === product_id && item?.variant_id === variant_id
        })
        let curBatch = products && products[0] && products[0]?.product && products[0]?.product?.batchs || []
        let newBatch = [...curBatch, ...ProductUtil.parseProductBatch(dataBatch)]
        if(products && products[0] && products[0]?.product){
            //update lại số lô
            product?.map((item:any, index:number)=>{
                if(item?.product_id === product_id && item?.variant_id === variant_id){
                    product[index].product.batchs = newBatch
                }
            })
            //set lại lô cho sp đang sửa
            product[indexProduct].batch_id = dataBatch[0]?.id 
            product[indexProduct].quantity = dataBatch[0]?.quantity_import
            const newProductBatch = dataBatch?.reduce((prev:any, item:any, index:number)=>{
                if(0 !== index){
                    prev = [...prev,{
                        ...products[0],
                        batch_id: item?.id,
                        quantity: item?.quantity_import
                    }]
                }
                return prev
            },[])
            setProduct([...product, ...newProductBatch])
        }
        
    }

    return (
        <div style={{paddingBottom:50}}>
            <React.Fragment>
                {
                    !from &&
                    <PageTitle
                        breadCrumbItems={[
                            { label: `${type == 'view' ? 'Xem chi tiết' : id ? 'Chỉnh sửa' : 'Thêm mới'} phiếu nhập hàng`, active: true },
                        ]}
                        title={`${type == 'view' ? 'Xem chi tiết' : id ? 'Chỉnh sửa' : 'Thêm mới'} phiếu nhập hàng`}
                    />
                }
                <ContentPage 
                    history={history}
                    data={data}
                    supplier={supplier}
                    setData={(val:any) => setData(val)}
                    supplierInfo={supplierInfo}
                    setSupplierInfo={(val:any) => setSupplierInfo(val)}
                    branch={branch}
                    product={product}
                    productTemplate={productTemplate}
                    stockRequestTemplate={stockRequestTemplate}
                    setProduct={(val:any) => setProduct(val)}
                    onlyView={onlyView}
                    id={id}
                    type={type}
                    action={action}
                    handleActionModal={(data:any) => handleActionModal(data)}
                    from={from}
                    closeModal={closeModal}
                    fetchCustomerExam={fetchCustomerExam}
                    payment={payment}
                    paymentMethod={paymentMethod}
                    setPayment={setPayment}
                />
                <ModalPopup
                    isOpen={modalIsOpen}
                    onRequestClose={() => setIsOpen(false)}
                >
                {action?.type === 'addBatch' ? 
                    <BatchAdd closeModal={() => setIsOpen(false)} action={action} onUpdateBatch={handleUpdateBatch} 
                    product_name={action?.data?.product?.name} 
                    product_id={action?.data?.product_id} 
                    variant_id={action?.data?.variant_id} 
                    sku={action?.data?.product?.sku} 
                    indexProduct={action?.indexProduct} 
                    />
                :action?.type === 'addPayment' ? 
                <PaymentAdd closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData(id)} import_id={action?.import_id} />
                :<RenderActionModal closeModal={() => setIsOpen(false)} action={action} loadData={() => {
                    loadData(id)
                    loadHistory(id)
                }} />
                }
                    
                </ModalPopup>
                {loading && <Loader />}
            </React.Fragment>
        </div>
    );
};

const ContentPage = (props:any) => {
    const {history, paymentMethod, supplierInfo, setSupplierInfo, data, type, setData, branch, onlyView, id, setProduct, product, productTemplate, stockRequestTemplate, supplier, payment, setPayment, action, handleActionModal, 
    from} = props
    const [loading, setLoading] = useState(false)
    const router = useHistory()
    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target
        if (value === " ") return;
        if (name === "phone" || name === "guardian_phone") {
            value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "")
        }
        if(value?.length > 1000) return;
        setData({
            ...data,
            [name]: value
        })
    }

    const handleProductAdd = () => {
        const newDetailtiveUser = {
            product_id: "",
            variant_id: "",
            product: {},
            quantity:"",
        };
        setProduct([...product, newDetailtiveUser]);
    };

    const handleProductUpdate = (dataDetail: any, index: number) => {
        // check xem đã có sp kia trong danh sách chưa nha
        const checkIsset = product?.reduce((prev:any, item:any, indexCheck:number)=>{
            if(indexCheck !== index && item?.product_id === dataDetail?.product_id && item?.variant_id === dataDetail?.variant_id){
                if(dataDetail?.product?.type !== 'batch'){
                    prev = false
                }else if(dataDetail?.product?.type === 'batch' && item?.batch_id === dataDetail?.batch_id){
                    prev = false
                } 
            }
            return prev
        }, true)
        if(!checkIsset){
            toast.warning('Sản phẩm đã được thêm')
            return
        }
        let newDetailtiveUser = cloneDeep(product);
        newDetailtiveUser[index] = dataDetail;
        setProduct(newDetailtiveUser);
    };

    const handleProductRemove = (index: number) => {
        let newDetailtiveUser = cloneDeep(product);
        newDetailtiveUser.splice(index, 1);
        if(newDetailtiveUser?.length === 0) newDetailtiveUser.push({
            product_id: "",
            variant_id: "",
            product_info: {},
            quantity:"",
        })
        setProduct(newDetailtiveUser);
    };

    const validationFrom = () => {
        if (!data.supplier_id) {
            toast.warning('Nhà cung cấp không được để trống!');
            return false
        }
        if (!data.branch_id) {
            toast.warning('Cơ sở (Kho) nhập không được để trống!');
            return false
        }
        
        const checkProduct = product?.reduce((prev:any, item:any)=>{
            if(
                !item?.product_id
                || !item?.quantity
                || (item?.product?.type === 'batch' && !item?.batch_id)
            ){
                prev = false
            }
            return prev
        }, true)
        if (!checkProduct) {
            toast.warning('Nhập đầu đủ thông tin sản phẩm');
            return false
        }
        const paymentCheck = payment?.reduce((prev:any, item:any)=>{
            if(
                (item?.payment_method_id && !item?.payment_total)
                || (!item?.payment_method_id && item?.payment_total)
            ){
                prev = false
            }
            return prev
        }, true)
        if(!paymentCheck){
            toast.warning('Hình thức hoặc số tiền không được để trống!');
            return false
        }
        return true
    }
    
    const handleSubmit = async(type?:string) => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/stock/import`;
        const stock_import_products = product?.reduce((prev:any, item:any)=>{
            prev = [...prev,{
                "product_id": item?.product_id,
                "variant_id": item?.variant_id || undefined,
                "quantity_request": item?.quantity_request ? Number(item?.quantity_request) : undefined,
                "quantity": Number(item?.quantity || 0),
                "price": Number(item?.price || 0),
                "discount": Number(item?.discount || 0),
                "unit_id": item?.unit_id ? item?.unit_id : undefined,
                "batch_id": item?.batch_id ? item?.batch_id : undefined,
            }]
            return prev
        },[])
        const stock_import_payments = payment?.reduce((prev:any, item:any)=>{
            if(item?.payment_total){
                prev = [...prev, {
                    id: item?.id || undefined,
                    payment_method_id: item?.payment_method_id,
                    payment_total: Number(item?.payment_total),
                }]
            }
            return prev
        },[])
        const params = {
            "supplier_id": data?.supplier_id,
            "branch_id": data?.branch_id,
            "code": data?.code,
            // "code_request": data?.code_request,
            "stock_request_id": data?.stock_request_id,
            "note": data?.note,
            "status": type === 'active' ? 1 : type === 'import' ? 2 : 0,
            "discount_value": Number(data?.discount_value || 0),
            "discount_type": data?.discount_type,
            "vat": Number(data?.vat || 0),
            "stock_import_products": stock_import_products,
            "stock_import_payments": stock_import_payments?.length > 0 ? stock_import_payments : undefined,
        }
        let response: any = await APIClient.POST(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Tạo mới phiếu nhập hàng thành công')
            router?.push(`/stockimport/${response.response?.id}/view`)
        }
    }

    const handleEdit = async() => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/stock/import/${id}`;
        const stock_import_products = product?.reduce((prev:any, item:any)=>{
            prev = [...prev,{
                "product_id": item?.product_id,
                "variant_id": item?.variant_id || undefined,
                "quantity_request": item?.quantity_request ? Number(item?.quantity_request) : undefined,
                "quantity": Number(item?.quantity || 0),
                "price": Number(item?.price || 0),
                "discount": Number(item?.discount || 0),
                "unit_id": item?.unit_id ? item?.unit_id : undefined,
                "batch_id": item?.batch_id ? item?.batch_id : undefined,
            }]
            return prev
        },[])
        const stock_import_payments = payment?.reduce((prev:any, item:any)=>{
            if(item?.payment_total){
                prev = [...prev, {
                    id: item?.id || undefined,
                    payment_method_id: item?.payment_method_id,
                    payment_total: Number(item?.payment_total),
                }]
            }
            return prev
        },[])
        const params = {
            "supplier_id": data?.supplier_id,
            "branch_id": data?.branch_id,
            "code": data?.code,
            // "code_request": data?.code_request,
            "stock_request_id": data?.stock_request_id,
            "note": data?.note,
            "status": 0,
            "discount_value": Number(data?.discount_value || 0),
            "discount_type": data?.discount_type,
            "vat": Number(data?.vat || 0),
            "stock_import_products": stock_import_products,
            "stock_import_payments": stock_import_payments?.length > 0 ? stock_import_payments : undefined,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Chỉnh sửa phiếu nhập hàng thành công')
            router?.push(`/stockimport/${response.response?.id}/view`)
        }
    }

    const handlePaymentAdd = () => {
        const newDetailtiveUser = {
            payment_id: "",
            quantity:"",
        };
        setPayment([...payment, newDetailtiveUser]);
    };

    const handlePaymentUpdate = (dataDetail: any, index: number) => {
        let newDetailtiveUser = cloneDeep(payment);
        newDetailtiveUser[index] = dataDetail;
        setPayment(newDetailtiveUser);
    };

    const handlePaymentRemove = (index: number) => {
        let newDetailtiveUser = cloneDeep(payment);
        newDetailtiveUser.splice(index, 1);
        setPayment(newDetailtiveUser);
    };

    const calTotal = ()=>{
        const totalPayment = product?.reduce((prev:any, item:any)=>{
            if(item?.price && item?.quantity) prev = prev + (Number(item?.price ||  0) * Number(item?.quantity || 0) - Number(item?.discount || 0))
            return prev
        },0)
        return Math.floor(totalPayment || 0)
    }

    const calTotalEnd = ()=>{
        const totalPayment = calTotal()
        const discount = Number(
            data?.discount_type === 'percent' ? Number(data?.discount_value || 0) * totalPayment / 100
            : Number(data?.discount_value || 0)
        )
        const vat = (totalPayment - discount) * Number(data?.vat || 0) / 100
        return Math.floor(totalPayment + vat - discount)
    }

    const calTotalPayment = ()=>{
        const totalPayment = payment?.reduce((prev:any, item:any)=>{
            if(item?.payment_total) prev = prev + Number(item?.payment_total)
            return prev
        },0)
        return Math.floor(totalPayment || 0)
    }

    const getLabelStatus = (status:any) => {
        switch(status) {
            case -1: {
                return <span className="ml-2 label-status bg-danger">Hủy phiếu</span>
                break;
            }
            case 0: {
                return <span className="ml-2 label-status bg-dark">Mới</span>
                break;
            }
            case 1: {
                return <span className="ml-2 label-status bg-success">Xác nhận</span>
                break;
            }
            case 2: {
                return <span className="ml-2 label-status bg-info">Nhập kho</span>
                break;
            }
            case 3: {
                return <span className="ml-2 label-status bg-danger">Chuyển hoàn</span>
                break;
            }
            default: {
                return null
                break;
            }
        }
    }

    const [loadingStockRequest, setLoadingStockRequest] = useState(false);
    const [queryStockRequest, setQueryStockRequest] = useState('')

    const handleInputChangeStockRequest = (newValue:any) => {
        setQueryStockRequest( newValue);
        return newValue;
    };

    const loadStockRequest = async () => {
        setLoadingStockRequest(true)
        let response: any = await APIClient.GET(`${baseUrl}/stock/request`,{
            page: 1,
            limit: 100,
            name: queryStockRequest
        });
        setLoadingStockRequest(false)
        if (response.response?.data !== undefined) {
            const ListArr = response.response?.data?.reduce((prev:any, item:any)=>{
                prev = [...prev,
                    {
                        label:item?.code,
                        value:item?.id
                    }
                ]
                return prev
            },[])
            return ListArr
        }else{
            return []
        }
    };

    return (
        <PageContent style={from=='exam' ? {width:'900px', maxHeight:'80vh', overflowX:'hidden'}: {}} className={onlyView ? 'only-view' : ''}>
            <Row>
                <Col md={9} xs={12}>
                    <PageBody>
                        <div className="nutri-title mb-3">Thông tin phiếu nhập hàng {getLabelStatus(data?.status)}</div>
                        <Row>
                            <Col md={3} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Nhà cung cấp</Label>
                                    <Select
                                        placeholder="Chọn nhà cung cấp"
                                        className="react-select mb-2"
                                        classNamePrefix="react-select"
                                        isDisabled={onlyView}
                                        onChange={(val: any) => {
                                            setData({ ...data, supplier_id: val?.value })
                                            setSupplierInfo(val)
                                        }}
                                        value={supplier?.filter(
                                            (option: any) => data?.supplier_id == option.value
                                        )}
                                        options={supplier}
                                        components={{ Menu: (props:any)=>(
                                            <components.Menu {...props} >
                                                {props.children}
                                                <Link to="/supplier/add" target="_blank" rel="noopener noreferrer" className='select-menu-add'>
                                                    <i className="uil-plus mr-1"></i> Tạo mới nhà cung cấp
                                                </Link>
                                            </components.Menu>
                                        )}}
                                        styles={{
                                            ...customStyles,
                                            menu: ({ width, ...css }) => ({
                                                ...css,
                                                minWidth: 300,
                                            }),
                                        }}
                                    ></Select>
                                </FormGroup>
                            </Col>
                            <Col md={3} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Cơ sở (Kho) nhập</Label>
                                    <Select
                                        placeholder="Chọn cơ sở"
                                        className="react-select mb-2"
                                        classNamePrefix="react-select"
                                        isDisabled={onlyView}
                                        onChange={(val: any) => {
                                            setData({ ...data, branch_id: val?.value })
                                        }}
                                        value={branch?.filter(
                                            (option: any) => data?.branch_id == option.value
                                        )}
                                        options={branch}
                                        components={{ Menu: (props:any)=>(
                                            <components.Menu {...props} >
                                                {props.children}
                                                <Link to="/setting/medicalbasis/add" target="_blank" rel="noopener noreferrer" className='select-menu-add'>
                                                    <i className="uil-plus mr-1"></i> Tạo mới cơ sở
                                                </Link>
                                            </components.Menu>
                                        )}}
                                        styles={{
                                            ...customStyles,
                                            menu: ({ width, ...css }) => ({
                                                ...css,
                                                minWidth: 400,
                                            }),
                                        }}
                                    ></Select>
                                </FormGroup>
                            </Col>
                            <Col md={3} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Mã phiếu</Label>
                                    {type === 'view' ?
                                        <ValueText className='only-view'>{data?.code}</ValueText>
                                        :<Input type="text" value={data?.code} onChange={(e: any) => handleChangeInput(e)} name="code" placeholder={(type=='view' && !data?.code) ? "---" : "Nhập mã phiếu"} />
                                    }
                                </FormGroup>
                            </Col>
                            <Col md={3} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Mã phiếu yêu cầu</Label>
                                    {type === 'view' ?
                                        <ValueText className='only-view'>{stockRequestTemplate?.filter(
                                            (option: any) => data?.stock_request_id == option.value
                                        )[0]?.label}</ValueText>
                                        :<AsyncSelect
                                            className="react-select"
                                            classNamePrefix="react-select"
                                            onInputChange={handleInputChangeStockRequest}
                                            loadOptions={loadStockRequest}
                                            inputValue={queryStockRequest}
                                            placeholder={loadingStockRequest ? "Đang tải dữ liệu..." : "Nhập tên, mã..."}
                                            noOptionsMessage={() => queryStockRequest ? "Không tìm thấy dữ liệu" : 'Nhập mã phiếu yêu cầu nhập'}
                                            loadingMessage={() => 'searching...'}
                                            styles={customStyles}
                                            cacheOptions 
                                            defaultOptions={stockRequestTemplate}
                                            onChange={(val: any) => {
                                                handleChangeInput({target:{value: val?.value, name: 'stock_request_id'}})
                                            }}
                                            value={stockRequestTemplate?.filter(
                                                (option: any) => data?.stock_request_id == option.value
                                            )}
                                            isDisabled={onlyView}
                                        />
                                    }
                                    {/* <Input type="text" value={data?.code_request} onChange={(e: any) => handleChangeInput(e)} name="code_request" placeholder={(type=='view' && !data?.code_request) ? "---" : "Nhập mã phiếu yêu cầu"} /> */}
                                </FormGroup>
                            </Col>
                            <Col md={12} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Ghi chú</Label>
                                    <Input type="text" value={data?.note} onChange={(e: any) => handleChangeInput(e)} name="note" placeholder={(type=='view' && !data?.note) ? "---" : "Nhập ghi chú"} />
                                </FormGroup>
                            </Col>
                        </Row>
                    </PageBody>
                    <PageBody>
                        <div className="nutri-title mb-3">Sản phẩm</div>
                        <div className="table-responsive" style={{overflow: 'unset'}}>
                            <table className="mb-0 table-custom no-bg table table-input" >
                                <thead>
                                    <tr>
                                        <th style={{ width: '20%' }}><span className='require'>*</span> Tên sản phẩm</th>
                                        <th style={{ width: '8%' }}><span className='require'>*</span> Mã SKU</th>
                                        <th style={{ width: '8%' }}>Mã Lô</th>
                                        <th style={{ width: '8%' }}><span className='require'>*</span> Đơn vị</th>
                                        <th style={{ width: '10%' }}>SL yêu cầu</th>
                                        <th style={{ width: '10%' }}><span className='require'>*</span> SL nhập</th>
                                        <th style={{ width: '10%' }}><span className='require'>*</span> Giá nhập</th>
                                        <th style={{ width: '10%' }}>Giảm giá</th>
                                        <th style={{ width: '10%' }}><span className='require'>*</span> Thành tiền</th>
                                        {!onlyView &&<th style={{ width: '6%' }}></th>}
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    product?.map((item:any, index:number) => (
                                        <ProductItem 
                                            handleActionModal={handleActionModal}
                                            detailIndex={index} 
                                            data={item}
                                            dataParent={data}
                                            onChangeData={(dataDetail: any) =>
                                                handleProductUpdate(dataDetail, index)
                                            }
                                            productTemplate={productTemplate}
                                            type={type}
                                            onlyView={onlyView}
                                            handleRemoveData={() => handleProductRemove(index)}
                                            handleAddData={() => handleProductAdd()}
                                            detail={product}
                                        />
                                    ))
                                }
                                </tbody>
                            </table>
                            <Col md={5} style={{float: 'right'}}>
                                <div style={{ display: 'flex', justifyContent:'space-between', width: '100%'}}>
                                    <ValueTextLabel>Tổng tiền </ValueTextLabel>
                                    <ValueTextValue className='only-view' style={{flexDirection: 'row-reverse'}}>{PriceUtils.format(calTotal())}</ValueTextValue>
                                </div>
                                <div className='mb-2' style={{ display: 'flex', justifyContent:'space-between', width: '100%'}}>
                                    <ValueTextLabel>Giảm giá </ValueTextLabel>
                                    <ValueTextValue>
                                        <div className='stock-import-discount-group'>
                                            <NumberFormat 
                                                disabled={type === 'view'}
                                                onChange={(e: any) => handleChangeInput({ target: { name: 'discount_value', value: TextUtils.onlyNumber(e.target.value) } })}
                                                name={'discount_value'} type={'text'} className="form-control discount_value" 
                                                value={type === 'view' && !data?.discount_value ? '---': data?.discount_value}
                                                placeholder={(type=='view' && !data?.discount_value) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                                            />
                                            <Select
                                                placeholder={(type=='view' && !data?.discount_type) ? "---" : "Chọn"}
                                                className="react-select discount_type"
                                                classNamePrefix="react-select"
                                                isDisabled={onlyView}
                                                onChange={(val: any) => handleChangeInput({ target: { name: 'discount_type', value: val?.value } })}
                                                value={DiscountType?.filter(
                                                    (option: any) => data?.discount_type == option.value
                                                )}
                                                options={DiscountType}
                                            ></Select>
                                        </div>
                                    </ValueTextValue>
                                </div>
                                <div style={{ display: 'flex', justifyContent:'space-between', width: '100%'}}>
                                    <ValueTextLabel>VAT </ValueTextLabel>
                                    <ValueTextValue>
                                        <div className='stock-import-discount-group'>
                                            <NumberFormat 
                                                disabled={type === 'view'}
                                                onChange={(e: any) => handleChangeInput({ target: { name: 'vat', value: TextUtils.onlyNumber(e.target.value) } })}
                                                name={'vat'} type={'text'} className="form-control discount_type" 
                                                value={type === 'view' && !data?.vat ? '---': data?.vat}
                                                placeholder={(type=='view' && !data?.vat) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                                            />
                                        </div>
                                    </ValueTextValue>
                                </div>
                                <div style={{ display: 'flex', justifyContent:'space-between', width: '100%'}}>
                                    <ValueTextLabel>Tổng tiền thanh toán: </ValueTextLabel>
                                    <ValueTextValue className='only-view' style={{flexDirection: 'row-reverse'}}>{PriceUtils.format(calTotalEnd())}</ValueTextValue>
                                </div>
                            </Col>
                            
                        </div>
                        
                    </PageBody>
                </Col>
                <Col md={3} xs={12}>
                    <div className="card">
                        <div className="card-body p-0">
                            <div style={{padding:' 1.25rem'}}>
                                <div className="mb-3" style={{display: 'flex', justifyContent:'space-between'}}>
                                    <div className="nutri-title">Thông tin thanh toán</div>
                                    {/* <div style={{display: 'flex', justifyContent:'space-between'}}>
                                        <ValueTextLabel>Tổng tiền: </ValueTextLabel>
                                        <ValueTextTotal className='only-view'>{PriceUtils.format(calTotalPayment())}</ValueTextTotal>
                                    </div> */}
                                    
                                </div>
                                {
                                    type != 'view' && payment?.length === 0 ?
                                    <div style={{display: 'flex', justifyContent: 'center'}}>
                                        <Button onClick={handlePaymentAdd} color='success'><i className='uil-plus'></i> Thêm phương thức thanh toán</Button>
                                    </div>
                                    :payment?.map((item:any, index:number) => (
                                        <PaymentItem 
                                            detailIndex={index} 
                                            data={item}
                                            onChangeData={(dataDetail: any) =>
                                                handlePaymentUpdate(dataDetail, index)
                                            }
                                            paymentMethod={paymentMethod}
                                            type={type}
                                            onlyView={onlyView}
                                            handleRemoveData={() => handlePaymentRemove(index)}
                                            handleAddData={() => handlePaymentAdd()}
                                            detail={payment}
                                        />
                                    ))
                                }
                            </div>
                            <div style={{
                                display: 'flex', 
                                justifyContent:'flex-end', 
                                background: '#ECECF2', 
                                padding:'8px 1.25rem', 
                                overflow: 'hidden', 
                                borderBottomRightRadius: '0.5rem',
                                borderBottomLeftRadius: '0.5rem',
                            }}>
                                <div style={{display: 'flex', justifyContent:'space-between', width: '100%'}}>
                                    <ValueTextLabel>Tổng công nợ hiện tại: </ValueTextLabel>
                                    <ValueTextLabel className='only-view' style={{flexDirection:'row-reverse'}}>{PriceUtils.format(supplierInfo?.total_debt || 0)}</ValueTextLabel>
                                    {/* <ValueTextLabel className='only-view' style={{flexDirection:'row-reverse'}}>{PriceUtils.format(calTotalEnd() - calTotalPayment())}</ValueTextLabel> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {type === 'view' && <History history={history}/>}
                </Col>
            </Row>
           
            {
                // !from &&
                <div className="bottom-action">
                    <Button color="success" className='dark-bland ml-2' onClick={() => router?.goBack()}>Đóng</Button>
                    {
                        !id && <>
                            
                            <Button color="info" className='ml-2' onClick={() => props?.handleActionModal({type: 'importConfirm', data: data, onSubmit:()=>handleSubmit('import') })}>Nhập kho</Button>
                            <Button color="success" className='success-bland ml-2' onClick={() => props?.handleActionModal({type: 'activeConfirm', data: data, onSubmit:()=>handleSubmit('active')})}>Xác nhận</Button>
                            <Button color="success" className='ml-2' onClick={()=>handleSubmit()}>Lưu</Button>
                        </>
                    }
                    {
                        id && type == 'view' && data?.status == 0 && 
                        <>
                            <Button color="success" className='success-bland ml-2' onClick={() => props?.handleActionModal({type: 'active', data: data})}>Xác nhận</Button>
                            <Button color="info" className='ml-2' onClick={() => props?.handleActionModal({type: 'import', data: data})}>Nhập kho</Button>
                            <Button color="success" className='danger-bland ml-2' onClick={() => props?.handleActionModal({type: 'reject', data: data})}>Hủy phiếu</Button>
                            <Button color="success" className='ml-2' onClick={() => router?.push(`/stockimport/${id}`)}>Chỉnh sửa</Button>
                        </>
                    }
                    {
                        id && type == 'view' && data?.status == 1 && 
                        <>
                            <Button color="info" className='ml-2' onClick={() => props?.handleActionModal({type: 'import', data: data})}>Nhập kho</Button>
                            <Button color="success" className='danger-bland ml-2' onClick={() => props?.handleActionModal({type: 'importReturn', data: data})}>Chuyển hoàn</Button>
                            <Button color="danger" className='ml-2' onClick={() => props?.handleActionModal({type: 'reject', data: data})}>Hủy phiếu</Button>
                        </>
                    }
                    {
                        id && type == 'view' && data?.status == 2 && data?.payment_status !== 'paid' &&
                        <>
                            <Button color="success" className='ml-2' onClick={() => props?.handleActionModal({type: 'addPayment', import_id: id})}>Thanh toán</Button>
                            
                        </>
                    }
                    {
                        id && type == 'view' && data?.status == 2 &&
                        <>
                            <Button color="success" className='ml-2' onClick={() => props?.handleActionModal({type: 'return', import_id: id})}>Trả hàng</Button>
                            
                        </>
                    }
                    {
                        id && type != 'view' &&
                        <Button color="success" className='ml-2' onClick={handleEdit}>Lưu</Button>
                    }
                </div>
            }
            
            {loading && <Loader />}
        </PageContent>
    )
}

const ProductItem = (props:any) => {
    const {detailIndex, detail, onChangeData, data, dataParent, productTemplate, type, onlyView, handleRemoveData, handleAddData, handleActionModal} = props
    const [loadingDesignation, setLoadingProduct] = useState(false);
    const [queryDesignation, setQueryDesignation] = useState('')

    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        onChangeData({
            ...data,
            [name]: value
        })
    }

    const loadProduct = async () => {
        setLoadingProduct(true)
        let response: any = await APIClient.GET(`${baseUrl}/product`,{
            page: 1,
            limit: 20,
            name: queryDesignation
        });
        setLoadingProduct(false)
        if (response.response?.data !== undefined) {
            const ListArr = ProductUtil.parseProduct(response.response?.data)
            return ListArr
        }else{
            return []
        }
    };

    const handleInputChangeProduct = (newValue:any) => {
        setQueryDesignation( newValue);
        return newValue;
    };

    const calTotalItem = ()=>{
        return Math.floor(
            Number(data?.price  || 0) * Number(data?.quantity  || 0) - Number(data?.discount  || 0)
        )
    }

    return (
        <tr key={`item-product-${detailIndex}`}>
            <td onClick={()=>{
                if(!dataParent?.supplier_id){
                    toast.warning("Bạn cần chọn trước Nhà cung cấp")
                }
            }}>
                <AsyncSelect
                    className="react-select"
                    classNamePrefix="react-select"
                    onInputChange={handleInputChangeProduct}
                    loadOptions={loadProduct}
                    inputValue={queryDesignation}
                    placeholder={loadingDesignation ? "Đang tải dữ liệu..." : "Nhập tên, mã..."}
                    noOptionsMessage={() => queryDesignation ? "Không tìm thấy dữ liệu" : 'Nhập tên, mã sản phẩm'}
                    loadingMessage={() => 'searching...'}
                    cacheOptions 
                    defaultOptions={productTemplate}
                    onChange={(val: any) => {
                        onChangeData({
                            ...data,
                            product_id: val?.product_id,
                            variant_id: val?.variant_id || undefined,
                            product: val,
                            batch_id: '',
                            unit_id: 0,
                            quantity: 1,
                            quantity_request: '',
                            price: val?.price_import,
                            discount: '',
                        })
                    }}
                    // value={productTemplate?.filter(
                    //     (option: any) => data?.product_id == option.product_id && data?.variant_id == option.variant_id
                    // )}
                    value={{
                        label: data?.product?.name
                    }}
                    isDisabled={onlyView || !dataParent?.supplier_id}
                    components={{ Menu: (props:any)=>(
                        <components.Menu {...props} >
                            {props.children}
                            <Link to="/product/add" target="_blank" rel="noopener noreferrer" className='select-menu-add'>
                                <i className="uil-plus mr-1"></i> Tạo mới sản phẩm
                            </Link>
                        </components.Menu>
                    )}}
                    styles={{
                        ...customStyles,
                        menu: ({ width, ...css }) => ({
                            ...css,
                            minWidth: 500,
                        }),
                    }}
                />
            </td>
            <td>
                <Input type="text" value={data?.product?.sku || ''} disabled={true} placeholder={(type=='view' && !data?.product?.sku) ? "---" : "Mã SKU"} />
            </td>
            
            {data?.product?.type === 'batch' ?
            <td style={{ width: '13%' }}>
                <Select
                    placeholder={(type=='view' && !data?.batch_id) ? "---" : "Chọn lô..."}
                    className="react-select"
                    classNamePrefix="react-select"
                    isDisabled={onlyView}
                    onChange={(val: any) => {
                        onChangeData({
                            ...data,
                            batch_id: val?.value,
                        })
                    }}
                    value={data?.product?.batchs?.filter(
                        (option: any) => data?.batch_id === option.value
                    )}
                    options={data?.product?.batchs}
                    noOptionsMessage={() => 'Chưa có lô'}
                    components={{ Menu: (props:any)=>(
                        <components.Menu {...props} >
                            {props.children}
                            <div className='select-menu-add' onClick={()=>{
                                handleActionModal({type: 'addBatch', data: data, indexProduct: detailIndex})
                            }}>
                                <i className="uil-plus mr-1"></i> Tạo lô
                            </div>
                        </components.Menu>
                    )}}
                    styles={{
                        menu: ({ width, ...css }) => ({
                            ...css,
                            minWidth: 200,
                        }),
                    }}
                ></Select>
            </td>:<td></td>
            }
            
            <td>
                <Select
                    placeholder={(type=='view' && !data?.unit_id) ? "---" : "Chọn đơn vị..."}
                    className="react-select"
                    classNamePrefix="react-select"
                    isDisabled={onlyView}
                    onChange={(val: any) => {
                        onChangeData({
                            ...data,
                            unit_id: val?.value,
                        })
                    }}
                    value={data?.product?.units?.filter(
                        (option: any) => data?.unit_id === option.value
                    )}
                    options={data?.product?.units}
                    noOptionsMessage={() => 'Chưa có đơn vị'}
                    styles={{
                        ...customStyles,
                        menu: ({ width, ...css }) => ({
                            ...css,
                            minWidth: 200,
                        }),
                    }}
                ></Select>
            </td>
            <td>
                <NumberFormat 
                    onChange={(e: any) => handleChangeData({ target: { name: 'quantity_request', value: TextUtils.onlyNumber(e.target.value) } })}
                    name={'quantity_request'} type={'text'} className="form-control" 
                    value={type === 'view' && !data?.quantity_request ? '---': data?.quantity_request}
                    disabled={onlyView}
                    placeholder={(type=='view' && !data?.quantity_request) ? "---" : "Nhập số lượng..."} thousandSeparator={true} 
                />
            </td>
            <td>
                <NumberFormat 
                    onChange={(e: any) => handleChangeData({ target: { name: 'quantity', value: TextUtils.onlyNumber(e.target.value) } })}
                    name={'quantity'} type={'text'} className="form-control" 
                    value={type === 'view' && !data?.quantity ? '---': data?.quantity}
                    disabled={onlyView}
                    placeholder={(type=='view' && !data?.quantity) ? "---" : "Nhập số lượng..."} thousandSeparator={true} 
                />
            </td>
            <td>
                <NumberFormat 
                    onChange={(e: any) => handleChangeData({ target: { name: 'price', value: TextUtils.onlyNumber(e.target.value) } })}
                    name={'price'} type={'text'} className="form-control" 
                    value={type === 'view' && !data?.price ? '---': data?.price}
                    disabled={onlyView}
                    placeholder={(type=='view' && !data?.price) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                />
            </td>
            <td>
                <NumberFormat 
                    onChange={(e: any) => handleChangeData({ target: { name: 'discount', value: TextUtils.onlyNumber(e.target.value) } })}
                    name={'discount'} type={'text'} className="form-control" 
                    value={type === 'view' && !data?.discount ? '---': data?.discount}
                    disabled={onlyView}
                    placeholder={(type=='view' && !data?.discount) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                />
            </td>
            <td>
                <NumberFormat 
                    name={'total'} type={'text'} className="form-control" 
                    value={calTotalItem()}
                    disabled={true}
                    placeholder={(type=='view' && !data?.total) ? "---" : "---"} thousandSeparator={true} 
                />
            </td>
            {(!onlyView && dataParent?.supplier_id) &&
            <td>
                {/* <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button> */}
                {
                    detail?.length == detailIndex+1 ?
                    <Button onClick={handleAddData} className='nutri-square' color='success'><i className='uil-plus'></i></Button> :
                    <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button>
                }
            </td>}
        </tr>
    )
}

const PaymentItem = (props:any) => {
    const {detailIndex, detail, onChangeData, data, type, onlyView, handleRemoveData, handleAddData, paymentMethod} = props
    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        if(name == 'name') {
            if(value?.length > 200) return
        }
        onChangeData({
            ...data,
            [name]: value
        })
    }
    
    return (
        <div className='payment-item' key={detailIndex}>
            <div className='payment-item-method'>
                <FormGroup className='nutri-form'>
                    <Label>Hình thức</Label>
                    <Select
                        placeholder={(type=='view' && !data?.payment_method_id) ? "---" : "Chọn"}
                        className="react-select mb-2"
                        classNamePrefix="react-select"
                        isDisabled={onlyView || data?.id}
                        onChange={(val: any) => handleChangeData({ target: { name: 'payment_method_id', value: val?.value } })}
                        value={paymentMethod?.filter(
                            (option: any) => data?.payment_method_id == option.value
                        )}
                        options={paymentMethod}
                    ></Select>
                </FormGroup>
            </div>
            <div className='payment-item-price'>
                <FormGroup className='nutri-form'>
                    <Label>Số tiền</Label>
                    <NumberFormat 
                        disabled={data?.id}
                        onChange={(e: any) => handleChangeData({ target: { name: 'payment_total', value: TextUtils.onlyNumber(e.target.value) } })}
                        name={'payment_total'} type={'text'} className="form-control" 
                        value={type === 'view' && !data?.payment_total ? '---': data?.payment_total}
                        placeholder={(type=='view' && !data?.payment_total) ? "---" : "Nhập số lượng..."} thousandSeparator={true} 
                    />
                </FormGroup>
            </div>
            {!onlyView &&
            <div className='payment-item-action'>
                <div style={{display:'flex', flexDirection: 'column'}}>
                    {!data?.id && <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button>}
                    {detail?.length == detailIndex+1 && <Button onClick={handleAddData} className='nutri-square mt-2' color='success'><i className='uil-plus'></i></Button>}
                </div>
            </div>}
        </div>
    )
}


const History = (props:any)=>{
    const {history} = props
    
    const HistoryItem = ({item, itemOld}:any)=>{
        if(!itemOld){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : item?.updated_time ?  moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.created_uid?.name || item?.updated_uid?.name}</td>
                    <td>Tạo phiếu: {TextUtils.getLabelByValue(StatusList, item?.status)}</td>
                </tr>
            )
        }else if(item?.updated_uid && item?.status !== itemOld?.status){
            return(
                <tr>
                    <td>{item?.updated_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Thay đổi trạng thái: {TextUtils.getLabelByValue(StatusList, item?.status)}</td>
                </tr>
            )
        }else if(item?.updated_uid){
            return(
                <tr>
                    <td>{item?.updated_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Chỉnh sửa thông tin</td>
                </tr>
            )
        }
        return(
            <tr>
                <td>{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : item?.updated_time ?  moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                <td>{item?.created_uid?.name || item?.updated_uid?.name}</td>
                <td>Tạo phiếu</td>
            </tr>
        )
    }


    return(
        <PageBody>
            <div className="nutri-title mb-3">Lịch sử thao tác</div>
            <div className="table-responsive" style={{overflow: 'unset'}}>
                <table className="mb-0 table-custom no-bg table table-input" >
                    <thead>
                        <tr>
                            <th style={{ width: '30%' }}>Thời gian</th>
                            <th style={{ width: '30%' }}>Người thực hiện</th>
                            <th style={{ width: '30%' }}>Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        history?.map((item:any, index:number) => (
                            <HistoryItem 
                                item={item}
                                itemOld={history && history[index-1]}
                            />
                        ))
                    }
                    </tbody>
                </table>
            </div>
            
        </PageBody>
    )
}

const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
`

const customStyles = {
    menuList: (base:any) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto"
      }),
  };

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`

const ValueTextLabel = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #1C1D21;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    flex: 2;
`


const ValueTextValue = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #1C1D21;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    flex: 3;
`
const ValueTextTotal = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #EDA119;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    margin-left: 20px;
`

const ValueTextTotalPayment = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #FD4858;
    margin-left: 20px;
`

export default connect(mapState)(Detail)